// extracted by mini-css-extract-plugin
export default {"container":"Location_container__6GkwB","name":"Location_name__6d5cB","icon":"Location_icon__9Zn6W","index":"Location_index__yHhjs","actions":"Location_actions__psJQa"};